import React from 'react';
import { FormControl, InputLabel, Select, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    formControl: {
        minWidth: 200,
        margin: '4px 0',
    },
    select: {
        background: "rgba(255, 255, 255, 0.8)",
        borderRadius: "8px",
        fontWeight: 600,
        color: "#009688",
        fontSize: "0.95rem",
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: "rgba(0, 0, 0, 0.15)",
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: "rgba(0, 0, 0, 0.3)",
        },
    },
    label: {
        fontSize: "0.95rem",
        fontWeight: 500,
        color: "#607d8b",
        background: '#f4f6f8', // Using a light background to hide the notch line. White works too. Let's use transparent if possible, or inherit.
    }
}));

export default function CustomDropdown(props) {
    const classes = useStyles();
    const { label, id, name, value, onChange, children, style, formControlStyle, fullWidth, className, ...rest } = props;
    const labelId = `${id || name}-label`;

    return (
        <FormControl variant="outlined" className={`${classes.formControl} ${className || ''}`} style={formControlStyle} fullWidth={fullWidth} size="small">
            {label && (
                <InputLabel id={labelId} className={classes.label} style={{ background: 'white', padding: '0 4px', marginLeft: '-4px' }}>
                    {label}
                </InputLabel>
            )}
            <Select
                labelId={labelId}
                id={id}
                name={name}
                value={value}
                onChange={onChange}
                label={label}
                className={classes.select}
                style={style}
                MenuProps={{
                    getContentAnchorEl: null,
                    anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "left",
                    },
                    transformOrigin: {
                        vertical: "top",
                        horizontal: "left",
                    },
                }}
                {...rest}
            >
                {children}
            </Select>
        </FormControl>
    );
}
